// extracted by mini-css-extract-plugin
export default {"tableTitle":"Tables_tableTitle__E5bKo"};